module.exports = __webpack_public_path__ + "img/somos_nuestros_resultados_blanco.e69601c0.png";